module.exports = __webpack_public_path__ + "static/holding-drone-e73ac2fa2df3dc9f28f5033ff813f883.jpg";